import { WizValidationErrorContainerDirective } from './wiz-validation-error-container.directive';
import { WizValidatorDirective } from './wiz-validator.directive';
import { WizValidationContainerDirective } from './wiz-validation-container.directive';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    WizValidationContainerDirective,
    WizValidatorDirective,
    WizValidationErrorContainerDirective
  ],
  exports: [
    WizValidationContainerDirective,
    WizValidatorDirective,
    WizValidationErrorContainerDirective
  ]
})
export class WizValidatorModule {
  constructor() { }
}
